import React ,{useState}from 'react'
import { Modal, Form, Input, Button, App } from 'antd';
import { useDept_addMutation, useUser_update_saveMutation } from '../../store/ReactWebSiteApi';
function DeptAdd(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [info, setInfo] = useState();
    const [Open, setOpen] = useState(false) 
    const [addDept] = useDept_addMutation();
    //修改用户部门权限
    const [submitEditUser] = useUser_update_saveMutation();
    return (
        <>
            <Button 
                style={{ marginLeft: '15px' }} 
                onClick={() => {
                    setOpen(true)                    
                }} 
                type='primary'
            >新增</Button>
            <Modal 
                destroyOnClose={true}
                open={Open}
                title="新增部门"
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                   
                form
                    .validateFields()
                    .then((values) => {
                        addDept({
                            ed_uid:localStorage.getItem('eu_id'),
                            ed_uname:localStorage.getItem('eu_name'),
                            ed_parent_id: localStorage.getItem('cur_dept_id'),
                            ed_e_id:localStorage.getItem('e_id'),
                            ed_name: info.ed_name,
                        })
                        .then((res) => {
                            if (res.data.Status === 'success') {
                                    let arr = props.userInfo.eu_dept_id.map((item) => {
                                        return item
                                    })
                                    arr.push(res.data.Result)
                                    submitEditUser({
                                        eu_id:localStorage.getItem('eu_id'),
                                        eu_e_id:localStorage.getItem('e_id'),
                                        eu_name:localStorage.getItem('eu_name'),
                                        eu_role:props.userInfo.eu_role,
                                        eu_uid: localStorage.getItem('eu_id'),
                                        eu_uname: localStorage.getItem('eu_name'),
                                        parent_dept_id:props.userInfo.parent_dept_id,
                                        eu_ba_phone:props.userInfo.eu_ba_phone, 
                                        eu_dept_id:arr,
                                        eu_show_authority:props.userInfo.eu_show_authority,
                                        eu_station_id:props.userInfo.eu_station_id,
                                    }).then((res) => {
                                            if (res.data.Status === 'success') {
                                                message.success('修改用户成功！'); 
                                                setOpen(false) 
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('修改用户失败！' + res.data.Message);
                                            }
                                        });
                                    setOpen(false);
                                }
                                if (res.data.Status === 'fail') {
                                message.error('新增失败！' + res.data.Message)
                            }
                        });
                        form.resetFields();                         
                    })
                    .catch((info) => {
                        console.log('Validate Failed:', info);
                    });
                }}
            >
                <Form
                    form={form}
                    name="addDept" 
                    labelCol={{span: 5,}}
                    wrapperCol={{span: 19,}}              
                >
                    <Form.Item
                        name="title"
                        label="名称"
                        rules={[
                        {
                            required: true,
                            message: '请填写子部门名称！',
                        },
                        ]}
                    >
                        <Input onChange={(e) => { setInfo(prevState => ({ ...prevState, ed_name: e.target.value }))}}  autoFocus={true}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default DeptAdd